module.exports = __webpack_public_path__ + "img/knight3_banner.6b463e56.jpg";